import { ApiEnvironment } from '../../models/api-environment';

export class CopilotMessagePublisherEnvironment extends ApiEnvironment {
  get publishUrl() {
    return `${this.baseUrl}/api/publish`;
  }

  get publishBulkUrl() {
    return `${this.baseUrl}/api/publish/bulk`;
  }

  get messagesUrl() {
    return `${this.baseUrl}/api/messages`;
  }

  usersMessagesUrl(userId: string) {
    return `${this.baseUrl}/api/v1/users/${encodeURIComponent(userId)}/messages`;
  }

  override resolve(environment: unknown) {
    return environment instanceof CopilotMessagePublisherEnvironment
      ? environment
      : this;
  }
}

export const copilotMessagePublisherEnvironment =
  new CopilotMessagePublisherEnvironment();
